import { Component, OnInit } from '@angular/core';
import { UsersService } from '../../services/users-service';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { Router } from '@angular/router';
import { RolesService } from '../../../roles/services/roles-service';
import { QueryModel } from '../../../../shared/Models/queryModel';
import { formatDate } from '@angular/common';
import { uploadService } from '../../../../shared/uploadService';
import { combineLatest, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss'],
})
export class AddUserComponent implements OnInit {
  model = {} as any;
  attachements = new FormData();
  isEdit = false;
  roles = [];
  query = new QueryModel();
  uploadThumbnail : boolean =true;
  formData = new FormData();
  validPhoto = false;
  constructor(
    private route : Router,
    private diagRef: NbDialogRef<AddUserComponent>,
    private service: UsersService,
    private toast: NbToastrService,
    private roleService : RolesService,
    private uploadservice : uploadService
  ) {}

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diagRef.close('false');
     });
         this.query.pageSize = 100;
    this.roleService.getAll(this.query, '').subscribe((res: any) => {
      this.roles = res.result;
    });
  }

    removePhoot() {
    this.uploadThumbnail = true;
    this.validPhoto = false;
  }

    validateEmail(): boolean {

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(this.model.email);
  }

  save() {
    const attachment$ = this.validPhoto ? this.uploadservice.uploadImage(this.formData) : of(null);

    combineLatest([ attachment$])
      .pipe(
        switchMap(([attachment]) => {
          if (attachment) {
            this.model.profilePictureFileName = attachment && attachment.fileName ? attachment.fileName : '';
          }
          if(!this.validateEmail())
          {
           this.toast.danger('  يرجي ادخال الايميل بشكل صحيح  ', 'خطأ', { status: 'success', duration: 4000 });
           return ;
          }
          return this.service.post( {  
      userName: this.model.email,
      email: this.model.email,
      name : this.model.name,
      rolesIds : this.model.rolesIds,
      profilePictureFileName : this.model.profilePictureFileName
    });
        })
      )
      .subscribe({
        next: (res) => {
          this.diagRef.close('true');
          this.toast.show('تم اضافة المستخدم بنجاح', '', { status: 'success', duration: 3000 });
        },
        error: (err) => {
          this.diagRef.close('true');
          this.toast.danger('خطأ في اضافة المستخدم ', 'خطأ', { status: 'success', duration: 3000 });
        },
      });
  }

    getFormData(event) {
    this.formData = event;
    if (event) this.validPhoto = true;
  }

  update() {
    if(this.validPhoto)
    {
     const attachment = this.uploadservice.uploadImage(this.formData);
     attachment.subscribe((res: any) => {
        if(res)
        {
          this.model.profilePictureFileName = res.fileName
        }
     });
    }

    this.service.put(this.model.id, this.model).subscribe((res) => {
      this.diagRef.close('true');
      this.toast.show('تم التعديل بنجاح', '', { status: 'success', duration: 3000 });
    });
  }

  close() {
    this.diagRef.close();
  }
}
